const listItems = [
  {
    id: '1',
    text: '<b>Consulte gratuitamente </b> seu CPF ou CNPJ',
  },
  {
    id: '2',
    text: '<b>Acesse as dívidas</b> geridas pela Recovery',
  },
  {
    id: '3',
    text: '<b>Selecione as dívidas</b> que deseja pagar com pagamentos que cabem no seu bolso',
  },
  {
    id: '4',
    text: '<b>Pague os boletos</b> em dia e fique livre de dívidas!',
  },
]

export default listItems
